import { render } from "./route-view.vue?vue&type=template&id=537a45e8"
import script from "./route-view.vue?vue&type=script&lang=ts"
export * from "./route-view.vue?vue&type=script&lang=ts"
script.render = render

export default script